<template>
  <div :class="{'categories-active': categoriesActive}">
    <transition name="fade" mode="out-in">
      <Btn
        primary
        isBlock
        pulse
        class="activate-categories"
        v-if="!categoriesActive"
        @click="activateCategories">
        Click to search
      </Btn>
    </transition>

    <div class="chat-panel" :class="{'is-searching': isSeaching}">
      <CategorySearch @filter="filter" />

      <div
        v-if="suggestion"
        class="button-wrapper suggestion"
        :class="{'is-active': activeClass(suggestionInfo)}"
        @click.prevent="setValue(suggestionInfo.slug)"
      >
        <div class="button-option">
          <button class="btn">
            <span>Suggested for you:</span> {{ suggestionInfo.name }}
          </button>
        </div>
      </div>

      <div class="button-options">
        <div
          class="button-wrapper"
          key="skip-1"
          :class="{'is-active': activeClass({slug: 'not-listed'})}"
          @click.prevent="setValue('not-listed')"
        >
          <div class="button-option">
            <button class="btn">
              Not Listed
            </button>
          </div>
        </div>

        <div
          class="button-wrapper"
          v-for="(option, index) in filteredOptions"
          :key="option.slug + index"
          :class="{'is-active': activeClass(option)}"
          @click.prevent="setValue(option.slug)"
        >
          <div class="button-option">
            <button class="btn">
              {{ option.name }}
            </button>
          </div>
        </div>

        <div
          class="button-wrapper"
          key="skip-2"
          :class="{'is-active': activeClass('not-listed')}"
          @click.prevent="setValue({slug: 'not-listed'})"
        >
          <div class="button-option">
            <button class="btn">
              Not Listed
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategorySearch from '@/components/chat/CategorySearch'
import Btn from '@/components/Btn'

export default {
  name: 'Category',

  components: {
    CategorySearch,
    Btn
  },

  props: {
    options: Array,
    suggestion: String
  },

  data() {
    return {
      value: '',
      filterQuery: '',
      categoriesActive: false
    }
  },

  watch: {
    value(answer) {
      this.$emit('input', answer)
    }
  },

  computed: {
    activeClass() {
      return (option) => {
        return option.slug === this.value
      }
    },

    isSeaching() {
      return this.filterQuery.length > 0
    },

    suggestionInfo() {
      let name = this.suggestion.replace(/-/g, ' ')

      return {
        name: name,
        slug: this.suggestion
      }
    },

    filteredOptions() {
      return this.options.filter((option) => {
        return option.slug
          .toLowerCase()
          .includes(this.filterQuery.toLowerCase())
      })
    }
  },

  methods: {
    setValue(value) {
      this.value = value
    },

    activateCategories() {
      this.categoriesActive = true
      this.$emit('categoriesActive', this.categoriesActive)
    },

    filter(value) {
      this.filterQuery = value
    },

    clearValue() {
      this.value = ''
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/base/variables'

form
  &.is-disabled
    .chat-panel
      animation: slideDown .5s ease-in-out

.button-options
  display: flex
  flex-wrap: wrap
  align-items: center

.categories-active
  .chat-panel
    animation: slideUp .5s ease-in-out
    animation-fill-mode: forwards

.chat-panel
  background: #fff
  padding: 0 6px 6px 6px
  position: absolute
  top: -360px
  height: 350px
  left: 0
  width: 100%
  overflow: scroll
  opacity: 0
  transition: visibility .5s ease-in-out
  -webkit-overflow-scrolling: touch
  box-shadow: 0 -12px 15px rgba(0, 0, 0, 0.2)
  border-radius: 5px

  // &:not(.is-searching)
  //   .button-wrapper
  //     &:first-child, &:last-child
  //       background: #efefef

  label
    margin: 0
    flex: 1
    font-size: 14px

.button-wrapper
  background: #f7f7f7
  margin: 10px
  padding: 8px
  cursor: pointer
  transition: all .2s ease-in-out
  opacity: 0
  animation: fadeIn .5s ease-in-out
  animation-fill-mode: forwards
  width: 100%

  @include media($media-gt-medium)
    display: flex
    flex-basis: calc(50% - 20px)
    min-height: 56px
    width: auto

  &.suggestion
    transform: translateY(-100%)
    animation: slideDown .5s 2s ease-in-out
    animation-fill-mode: forwards

  &.is-active
    transform: scale(1.05)
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1)

    @include themify($themes)
      background: themed('color-secondary')

      .btn
        color: #fff

    &.suggestion
      transform: scale(1)

      @include themify($themes)
        background: themed('color-primary')

      span
        color: #FFF

    button
      color: #FFF

    .sprite
      fill: #FFF

.suggestion
  position: sticky
  top: -6px
  background: #fff
  marign-bottom: $gap-small
  box-shadow: 0px 6px 6px -1px rgba(0, 0, 0, 0.1)
  z-index: 1

  span
    @include themify($themes)
      color: themed('color-primary')

.button-option
  display: flex
  align-items: center
  width: 100%
  transition: transform .2s ease-in-out

  .btn
    padding: 0
    text-align: left

    @include themify($themes)
      color: themed('color-secondary')

.activate-categories
  position: absolute
  z-index: 1
  width: calc(100% - #{$gap-medium})

  @include media($media-gt-x-large)
    right: $gap-small
    top: 50%
    transform: translateY(-50%)
    width: auto
</style>
